import { Game } from 'chessboard/model/game/types';

/**
 * Determine from the flags if a move is a promotion.
 */
export function isPromotion(move: Game.Move.Model): boolean {
  return (
    move.flags === Game.Move.Flags.Promotion || move.flags === Game.Move.Flags.CapturePromotion
  );
}
